
export default {
  name: 'ComponentGalaxyLoginPassword',
  components: {},
  props: {},
  data: () => ({
    form: { email: '', password: '' }
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    },
    validity() {
      return (
        this.$refs.email && this.$refs.password
        // this.$refs.email.checkValidity() &&
        // this.$refs.password.checkValidity()
      )
    },
    galaxyURL() {
      return this.$store.getters['galaxy/url']
    }
  },
  created() {},
  mounted() {
    // this.showSnackbar({
    //   msg: 'HI',
    //   color: 'danger'
    // })
  },
  methods: {
    async loginWithPassword() {
      try {
        let res = await this.$fire.auth
          .signInWithEmailAndPassword(this.form.email, this.form.password)
          .catch((error) => {
            this.showSnackbar({ msg: error.code, color: 'danger' })
            console.error(error)
            this.pushEvent({
              eventName: 'login_fail',
              eventDetails: {
                error_message: error.message,
                login_provider: 'email_password'
              }
            })
            return false
          })
        if (res) {
          const token = await this.$fire.auth.currentUser.getIdToken()
          this.$store.commit('firebase/setToken', {
            token
          })
          this.$store.commit('firebase/setUser', {
            user: this.$fire.auth.currentUser
          })
          await this.$store.dispatch('firebase/createCustomToken', {
            uid: this.$fire.auth.currentUser.uid
          })
          let res = await this.$store.dispatch('galaxy/getUser', {
            uid: this.$fire.auth.currentUser.uid
          })
          if (!res || !res.data) {
            this.showSnackbar({
              msg: 'You do not have an account or invitation.',
              color: 'danger'
            })
            await this.$fire.auth.signOut()
            this.$store.commit('galaxy/setUser', { data: false })
            this.$store.commit('firebase/setToken', {
              token: ''
            })
            this.$store.commit('firebase/setUser', {
              user: null
            })
            this.pushEvent({
              eventName: 'login_fail',
              eventDetails: {
                error_message: 'You do not have an account or invitation.',
                login_provider: 'email_password'
              }
            })
          } else {
            this.pushEvent({
              eventName: 'login_complete',
              eventDetails: {
                login_provider: 'email_password'
              }
            })
            this.setReferralCookie()
            window.location.href = this.galaxyURL
          }
        }
      } catch (error) {
        this.pushEvent({
          eventName: 'login_fail',
          eventDetails: {
            error_message: error.message,
            login_provider: 'email_password'
          }
        })
        console.error(error)
        this.showSnackbar({
          msg: error.code,
          color: 'danger'
        })
      }
    },
    setReferralCookie() {
      this.$cookies.set('galaxy-referrer', 'website', {
        path: '/',
        secure: Boolean(document.location.hostname != 'localhost'),
        maxAge: 20,
        domain:
          document.location.hostname == 'localhost'
            ? 'localhost'
            : '.digitl.net'
      })
    }
  }
}
